import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import './Login.css'

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [remember, setRemember] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const login = useAuthStore((state) => state.login)
  const navigate = useNavigate()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      await login(email, password)
      navigate('/')
    } catch (err) {
      setError(err instanceof Error ? err.message : 'ログインに失敗しました')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="login-page">
      <div className="login-container">
        <header className="login-header">
          <h1 className="login-title">FMT-Japan</h1>
          <p className="login-subtitle">一般財団法人腸内フローラ移植臨床研究会</p>
        </header>

        <main className="login-main">
          <h2 className="login-heading">ログイン</h2>

          {error && (
            <div className="login-error">
              <span className="material-symbols-outlined">error</span>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="login-form">
            <div className="aip-floating-field">
              <label className="aip-floating-field__label" htmlFor="email">
                メールアドレス
              </label>
              <input
                className="aip-floating-field__control aip-input-text"
                type="email"
                id="email"
                name="email"
                placeholder="example@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
              />
            </div>

            <div className="aip-floating-field">
              <label className="aip-floating-field__label" htmlFor="password">
                パスワード
              </label>
              <div className="aip-input-password">
                <input
                  className="aip-floating-field__control aip-input-password__input"
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="aip-input-password__toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label={showPassword ? 'パスワードを隠す' : 'パスワードを表示'}
                >
                  <span className="material-symbols-outlined">
                    {showPassword ? 'visibility_off' : 'visibility'}
                  </span>
                </button>
              </div>
            </div>

            <div className="login-options">
              <label className="aip-checkbox">
                <span className="aip-checkbox__checkbox">
                  <input
                    className="aip-checkbox__input"
                    type="checkbox"
                    name="remember"
                    checked={remember}
                    onChange={(e) => setRemember(e.target.checked)}
                  />
                </span>
                <span className="aip-checkbox__label">ログイン状態を保持する</span>
              </label>
            </div>

            <button
              type="submit"
              className="aip-button aip-button--solid-fill aip-button--full-width"
              disabled={loading}
            >
              {loading ? 'ログイン中...' : 'ログイン'}
            </button>
          </form>

          <div className="login-footer">
            <Link to="/password-reset" className="aip-link">
              パスワードをお忘れですか？
            </Link>
          </div>

          {/* デモ用アカウント情報 */}
          <div className="login-demo-info">
            <h3>デモアカウント</h3>
            <ul>
              <li>
                <strong>管理者:</strong> tanaka@fmt-japan.org / password123
              </li>
              <li>
                <strong>事務局:</strong> mizutani@fmt-japan.org / password123
              </li>
              <li>
                <strong>医療機関:</strong> yoshioka@base-clinic.jp / password123
              </li>
            </ul>
          </div>
        </main>
      </div>
    </div>
  )
}




